export default "__VITE_PUBLIC_ASSET__34cfa316__"